var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('em',{staticClass:"fas fa-circle",class:{
  'text-default': _vm.status === '',
  'text-danger': _vm.status === 'error',
  'text-warning': _vm.status === 'disabled',
  'text-success': _vm.status === 'created',
  'text-info': _vm.status === 'in_process'
}})}
var staticRenderFns = []

export { render, staticRenderFns }